import React from "react";
import styles from "./Auditor.module.scss";
import CardRow from "../../components/_shared/card-row/CardRow";

const Auditor_data = [
  {
    title: "Raporti i Auditorit dhe pasqyrat financiare për vitin 2025",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Raporti%20i%20Auditmit%20dhe%20Pasqyrat%20Financiare%20Individuale%20Pe%CC%88r%20vitin%20qe%CC%88%20pe%CC%88rfundon%20me%CC%88%2031%20Dhjetor%202025_0001.pdf",
    },
  },
  {
    title: "Raporti i Auditorit dhe pasqyrat financiare për vitin 2024",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Raporti-i-auditorit-te-pavarur-dhe-pasqyrat-financiare-individuale-per-fundin-e-vititme-31-Dhjetor-2024.pdf",
    },
  },
  {
    title: "Raporti i Auditorit dhe pasqyrat financiare për vitin 2023",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Raporti-i-Auditorit-te-Pavarur-dhe-Pasqyrat-Financiare-Individuale-Per-fundin-e-vitit-31-Dhjetor-2023.pdf",
    },
  },
  {
    title: "Raporti i Auditorit dhe pasqyrat financiare për vitin 2022",
    navigationLink: {
      title: "lexo dokument",
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Raporti-i-Auditorit-te-Pavauar-dhe-Pasqyrat-Financiare-Individuale-per-fundin-e-vitit-me-31-Dhjetor-2022.pdf",
    },
  },
  {
    title: "Raporti i Auditorit dhe pasqyrat financiare për vitin 2021",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/ffk-1-AUDITORI-2021.pdf",
    },
  },
  {
    title: "Raporti i Auditorit dhe pasqyrat financiare për vitin 2020",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Raport-auditorit-2020.pdf",
    },
  },
  {
    title: "Raporti i Auditorit dhe pasqyrat financiare për vitin 2019",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Raporti_i_Auditorit-2019.pdf",
    },
  },
  {
    title: "Raporti i Auditorit dhe pasqyrat financiare për vitin 2018",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Raporti-auditorit-2018.pdf",
    },
  },
  {
    title: "Raporti i Auditorit dhe pasqyrat financiare për vitin 2017",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Raporti-Financiar-2017.pdf",
    },
  },
  {
    title: "Raporti i Auditorit dhe pasqyrat financiare për vitin 2016",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Raporti-financiar-2016.pdf",
    },
  },
  {
    title: "Raporti i Auditorit dhe pasqyrat financiare për vitin 2015",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Pasqyrat-Financiare-2015.pdf",
    },
  },
  {
    title: "Raporti i Auditorit dhe pasqyrat financiare për vitin 2014",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Raporti-i-Auditorit-te-pavarur-dhe-pasqyrat-financiare-2014.pdf",
    },
  },
  {
    title: "Raporti i Auditorit dhe pasqyrat financiare për vitin 2013",
    navigationLink: {
      link: "https://minio.linkplus.dev:9000/ffk/PDFs/Raporti-i-auditorit-2013.pdf",
    },
  },
];

const Auditor = () => {
  return (
      <div className={styles.MainWrapper}>
        <div className={styles.PrimaryTitleWrapper}>
          <h1>Auditori</h1>
        </div>
        <div className={styles.ListWrapper}>
          {Auditor_data.map((data, index) => (
              <CardRow
                  key={index}
                  data={{
                    ...data,
                    id: index + 1,
                    navigationLink: {
                      ...data.navigationLink,
                      link: "Lexo Dokumentin",
                      onLinkClick: () =>
                          window.open(data.navigationLink?.link, "_blank"),
                    },
                  }}
                  colors="INVERTED"
              />
          ))}
        </div>
      </div>
  );

};

export default Auditor;
